import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../providers';
import { ChangepasswordPage } from '../changepassword/changepassword';

/**
 * Generated class for the ForgotPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-forgot',
  templateUrl: 'forgot.html',
})
export class ForgotPage {

  account: { email: string, password: string } = {
    email: '',
    password: ''
  };

  private loginErrorString: string;
  loading: Loading;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    public translateService: TranslateService, 
    public user: User, 
    public loadingController: LoadingController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController) {

    this.account = {
      email: '',
      password: ''
    };

    this.translateService.get('LOGIN_ERROR').subscribe((value) => {
      this.loginErrorString = value;
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgotPage');
  }

  forgot() {
    console.log("mail: "+this.account.email);

    var url = "accounts/reset";

    this.loading = this.loadingController.create({content : "Iniciando, porfavor espera un momento..."});
    this.loading.present();

    this.user.sendMailRecover(url, { "email": this.account.email }).subscribe((resp) => {
      console.log("Ok: status: "+resp);
      console.log("Ok: data: "+ JSON.stringify(resp)); // data received by server
      //console.log("Ok: headers: "+resp.headers); 
      //this.showAlert("Ok: "+JSON.stringify(resp), "Resp: "+resp);
      this.account = {
        email: '',
        password: ''
      };
      this.loading.dismissAll();
      this.navCtrl.setRoot(ChangepasswordPage, { user : resp });
      this.navCtrl.popToRoot();
    }, (err) => {
      console.log("Ok: status: "+err);
      console.log("Ok: data: "+ JSON.stringify(err)); // data received by server
      //console.log("Ok: headers: "+resp.headers); 
      //this.showAlert("Ok: "+JSON.stringify(err), "Resp: "+err);
      //this.navCtrl.push(MainPage);
      // Unable to log in
      this.showAlert("Error",""+JSON.stringify(err));
      let toast = this.toastCtrl.create({
        message: this.loginErrorString,
        duration: 3000,
        position: 'top'
      });
      this.loading.dismissAll();
      toast.present();
    });
  }

  showAlert(tit: string, msj: string) {
    const alert = this.alertCtrl.create({
      title: tit,
      subTitle: msj,
      buttons: ['Aceptar']
    });
    alert.present();
  }

  changePass() {
    this.navCtrl.push(ChangepasswordPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot/forgot.ts